import { render, staticRenderFns } from "./ManageApp.vue?vue&type=template&id=32136e72&"
import script from "./ManageApp.vue?vue&type=script&lang=js&"
export * from "./ManageApp.vue?vue&type=script&lang=js&"
import style0 from "./ManageApp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports